import { BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import React from 'react'

export function RequestDrawerViewOnly({ requestItem }) {
  return (
    <Vertical className='p-0 m-0 full-height-width' style={{ margin: 0, padding: 0 }} justifyContent='space-between'>
      <>
        <hr className='operations-hr' />
        <Horizontal
          style={{ height: 'fit-content' }}
          className='m-2 bg-2'
          alignItems='space-between'
          justifyContent='space-evenly'
        >
          <Vertical flex={2} className='p-4'>
            <Texto className='pb-2'>Title</Texto>
            <Texto>{requestItem?.subject} </Texto>
          </Vertical>
          <Vertical flex={2} className='p-4'>
            <Texto className='pb-2'>Site</Texto>
            <Texto>{requestItem?.site} </Texto>
          </Vertical>
          <Vertical flex={1.5} className='p-4'>
            <Texto className='pb-2'>Type</Texto>
            <Texto>{requestItem?.type} </Texto>
          </Vertical>
          <Vertical flex={0.75} className='p-4'>
            <Texto className='pb-2'>From Date</Texto>
            <Texto>{formatters.DATE(requestItem?.from_date)} </Texto>
          </Vertical>
          <Vertical flex={0.75} className='p-4'>
            <Texto className='pb-2'>To Date</Texto>
            <Texto>{formatters.DATE(requestItem?.to_date)} </Texto>
          </Vertical>
          <Vertical flex={0.75} className='p-4'>
            <Texto className='pb-2'>Status</Texto>
            {requestItem?.status === 'open' ? (
              <BBDTag className='pt-1 pb-1 mt-1' theme2>
                Open
              </BBDTag>
            ) : (
              <BBDTag success> Complete </BBDTag>
            )}
          </Vertical>
        </Horizontal>
        <hr className='operations-hr' />

        <Horizontal flex={3} className='p-4 mr-4 ml-4 ' horizontalCenter>
          <Vertical className='mr-4 ml-4' style={{ maxWidth: '1250px' }}>
            <div dangerouslySetInnerHTML={{ __html: requestItem?.note }} className='operations-request-view-note' />
          </Vertical>
        </Horizontal>
      </>
      <>
        <Horizontal verticalCenter justifyContent='space-between' className='owner-select-box p-4'>
          <Texto className='ml-4 pl-4' appearance='white' category='h4'>
            Owner
          </Texto>
          <Texto className='pr-4 mr-4' appearance='white' category='h4'>
            {requestItem?.owner || 'Needs Assignment'}
          </Texto>
        </Horizontal>
      </>
    </Vertical>
  )
}
